import * as React from 'react';
import styled from 'styled-components';
import {getCurrentLocale} from '../../utils/i18n';

const SocialLinksContainer = ({minWidth}) => {
    let language = getCurrentLocale();

    return (
        <HStack minWidth={minWidth}>
            <LinkButton
                image={require('../../assets/bt_instagram.png')}
                href={
                    language === 'por'
                        ? 'https://www.instagram.com/cartoonitobrasil/'
                        : 'https://www.instagram.com/cartoonitola/'
                }
                target="_blank"
            />
            <LinkButton
                image={require('../../assets/bt_facebook.png')}
                href={
                    language === 'por'
                        ? 'https://www.facebook.com/CartoonitoBrasil/'
                        : 'https://www.facebook.com/CartoonitoLatam/'
                }
                target="_blank"
            />
            <LinkButton
                image={require('../../assets/bt_emailmail.png')}
                href={
                    language === 'por'
                        ? 'mailto:tamoai@cartoonnetwork.com'
                        : 'mailto:hola@cartoonnetwork.com'
                }
                target="_blank"
            />
        </HStack>
    );
};

const HStack = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    ${props => props.minWidth && `min-width: ${props.minWidth}px`};
`;

const LinkButton = styled.a`
    background-image: ${props => `url(${props.image})`};
    width: 33px;
    height: 33px;
    background-size: contain;
`;

export default SocialLinksContainer;
